import type { SvelteComponent } from 'svelte';
import type { TOverlayData } from './types';

type TLayoutOrPageComponent = typeof SvelteComponent<{ data: TOverlayData }>;
type TOverlayPagesComponents = {
    [template: string]: {
        page: TLayoutOrPageComponent;
        layout?: TLayoutOrPageComponent;
    };
};

// EAGERLY IMPORT OVERLAY PAGES
const pages = import.meta.glob<true, string, TLayoutOrPageComponent>(
    '$pages/**/\\(overlay\\)/*/+page*.svelte',
    {
        import: 'default',
        eager: true
    }
);
// EAGLY IMPORT OVERLAY LAYOUTS
const layouts = import.meta.glob<true, string, TLayoutOrPageComponent>(
    '$pages/**/\\(overlay\\)/*/+layout*.svelte',
    {
        import: 'default',
        eager: true
    }
);

// Parse the imports and map to the template (route id)
const overlayPageLoadingFunctions: TOverlayPagesComponents = {};
const extractPathToTemplate = (
    importDeclarationObject: Record<string, TLayoutOrPageComponent>,
    type: 'page' | 'layout'
) => {
    Object.keys(importDeclarationObject).forEach((path) => {
        //extract tempalte name
        const template = path.substring(`/src/routes`.length, path.lastIndexOf('/'));
        // get the template item or new object
        const templateItem = overlayPageLoadingFunctions[template] || {};
        // assign the page or layout to the template item
        templateItem[type] = importDeclarationObject[path];
        // reassing the template item to the template
        overlayPageLoadingFunctions[template] = templateItem;
    });
};

// HAS SIDE EFFECTS - populates overlayPageLoadingFunctions
extractPathToTemplate(pages, 'page');
// HAS SIDE EFFECTS - populates overlayPageLoadingFunctions
extractPathToTemplate(layouts, 'layout');
// Make available for PageHandler

export { overlayPageLoadingFunctions };
